import { addErrorToast } from '@taxfix/scouts-ui'

import { CompanyReturnPriceDTO, CompanyReturnPriceValidationErrors } from '@/models'

type HandleCompanyReturnPriceValidation = (response: CompanyReturnPriceDTO) => void

// @TODO: Remove this file once validation is handled via error response

const getValidationErrorMessages = (validationErrors: CompanyReturnPriceDTO['validationErrors']) => {
    if (!validationErrors || !validationErrors?.length) return []

    return validationErrors
        .map((validationError) => {
            // Try to find a custom message for the validation error
            if (validationError.key && validationError.key in CompanyReturnPriceValidationErrors)
                return CompanyReturnPriceValidationErrors[validationError.key]

            const validationErrorMessageFromServer = validationError.value
            return validationErrorMessageFromServer || ''
        })
        .filter(Boolean) // Filter out empty messages
}

export const handleCompanyReturnPriceValidation: HandleCompanyReturnPriceValidation = (companyReturnPrice) => {
    if (companyReturnPrice?.validationErrors && companyReturnPrice?.validationErrors.length) {
        const toastMessages = getValidationErrorMessages(companyReturnPrice.validationErrors)
        toastMessages.forEach((body) => addErrorToast({ body }))
    }

    // In addition, show toast that it's not a generic error, but it's price causing errors
    addErrorToast({
        body: 'Unable to find the price for this company return. Please go back and answer all questions.',
    })

    // return { errors: true }
}
